export default "__VITE_ASSET__25832c9f__"